/** One comparison period and what the pull did with it. */
export interface ErpSyncOutcomeRow {
    readonly label: string;
    /** Already translated by the container — this view holds no vocabulary of its own. */
    readonly outcome: string;
    /** Drives the colour: only a failure is worth an alarm. */
    readonly failed: boolean;
}

/** What a finished pull has to report. Formatted by the container, which owns the language. */
export interface ErpSyncSummary {
    /** The closing's own period, as one readable range. */
    readonly period: string;
    readonly accountsInErp: number;
    readonly accountsJournalOnly: number;
    readonly statesCreated: number;
    readonly comparisonPeriods: readonly ErpSyncOutcomeRow[];
    /** Documents whose VAT code the ERP would not hand over. */
    readonly vatDocumentsUnreadable: number;
}

/** The vendor being pulled from, for the logo. */
export interface ErpSyncVendor {
    readonly logoSrc: string;
    readonly name: string;
}
